const moment = require('moment');
const AVAILABLE_LANGUAGES = require('./Languages');

const SETTINGS_FIELDS = {
    CURRENCY               : 'currency',
    DEFAULT_CURRENCY       : 'defaultCurrency',
    AVAILABLE_LANGUAGES    : 'availableLanguages',
    LANGUAGE               : 'language',
    CHECKIN                : 'checkIn',
    CHECKOUT               : 'checkOut',
    CHILDREN_ENABLED       : 'childrenEnabled',
    MAX_CHECKOUT_DATE      : 'maxCheckOutDate',
    MAX_CHILD_AGE          : 'maxChildAge',
    MIN_CHILD_AGE          : 'minChildAge',
    MAX_OCCUPANCY          : 'maxOccupancy',
    MAX_ROOMS_PER_BOOKING  : 'maxRoomsPerBooking',
    MIN_OCCUPANCY          : 'minOccupancy',
    DEFAULT_OCCUPANCY      : 'defaultOccupancy',
    DOMAIN                 : 'domain',
    PROMOTION_CODE_ENABLED : 'promotionalCodeEnabled',
    CURRENCY_DISPLAY       : 'currencyDisplay',
    AVAILABLE_CURRENCIES   : 'availableCurrencies',
    PROPERTY_CODE          : 'propertyCode',
    ON_VIEW_ROOMS          : 'onViewRooms',
    CHANNEL_ID             : 'channelId',
    IS_MULTI_PROPERTY      : 'isMultiProperty',
    HOTELS_FILTERS         : 'hotelsFilters',
    NEW_TAB_DISABLED       : 'newTabDisabled',
    SORT_ORDER             : 'sortOrder',
    ECHO_API_URL           : 'echoApiUrl',
    LOS                    : 'los',
    SEARCH_ID              : 'searchId',
    PRICE_CALC_MODE        : 'priceCalcMode',
    PRICE_DISPLAY_MODE     : 'priceDisplayMode',
    URL_TRANSFORMERS       : 'urlTransformers',
};

const CUSTOMIZATION_FIELDS = {
    STYLES     : 'styles',
    CONFIG     : 'config',
    SEARCH_BAR : 'searchbar',
    RATES      : 'rates',
    OFFERS     : 'offers',
};

const BOOTSTRAP_CONFIG_KEYS = {
    AUTOCOMPLETE           : 'autocomplete',
    CHECKIN                : 'checkIn',
    CHECKOUT               : 'checkOut',
    ALTERNATIVE_OFFERS     : 'alternativeOffers',
    PROMOTION_CODE_ENABLED : 'promotionalCodeEnabled',
    DEFAULT_OCCUPANCY      : 'defaultOccupancyConf',
    CHILDREN_ENABLED       : 'childrenEnabled',
    MAX_ROOMS_PER_BOOKING  : 'maxRoomsPerBooking',
    CURRENCY_DISPLAY       : 'currencyDisplay',
    LANGUAGE               : 'language',
    AVAILABLE_LANGUAGES    : 'availableLanguages',
    MAX_CHECKOUT_OFFSET    : 'maxCheckoutOffset',
    MAX_CHILD_AGE          : 'maxChildAge',
    MIN_CHILD_AGE          : 'minChildAge',
    MAX_OCCUPANCY          : 'maxOccupancy',
    MIN_OCCUPANCY          : 'minOccupancy',
    AVAILABLE_CURRENCIES   : 'availableCurrencies',
    DEFAULT_LOS            : 'defaultLengthOfStay',
    COUPON_INTEGRATION     : 'couponIntegration',
    COUPON_VOUCHER_TERM    : 'couponVoucherTerm',
    MIN_LOS                : 'minLengthOfStay',
    MAX_LOS                : 'maxLengthOfStay',
    MIN_NIGHT_OFFSET       : 'minNightOffset',
    BLACKOUT_PERIODS       : 'blackoutPeriods',
    CALENDAR_PRICE_MODE    : 'calendarPrices',
    PRICE_CALC_MODE        : 'priceCalcMode',
    PRICE_DISPLAY_MODE     : 'priceDisplayMode',
    SEARCH_BAR             : 'searchBar',
    SEARCH_BAR_WIDGET      : 'searchBarWidget',
};

const checkIn = moment().add(15, 'd').format('YYYY-MM-DD');
const checkOut = moment(checkIn).add(5, 'd').format('YYYY-MM-DD');
const maxCheckOutDate = moment().add(730, 'd').format('YYYY-MM-DD');

const DEFAULT_VALUES = {
    checkIn,
    checkOut,
    maxCheckOutDate,
    channelId: null,
    currency: {
        code   : 'EUR',
        symbol : '€',
    },
    defaultCurrency: {
        code   : 'EUR',
        symbol : '€',
    },
    currentCurrency: {
        code   : 'EUR',
        symbol : '€',
    },
    sortOrder          : 'native',
    availableLanguages : AVAILABLE_LANGUAGES,
    language           : '',
    childrenEnabled    : true,
    maxChildAge        : 6,
    minChildAge        : 0,
    maxOccupancy       : 12,
    maxRoomsPerBooking : 5,
    minOccupancy       : 1,
    defaultOccupancy   : {
        adults   : 2,
        children : [],
    },
    domain                 : '',
    promotionalCodeEnabled : false,
    currencyDisplay        : 'code',
    availableCurrencies    : {
        EUR: {
            code   : 'EUR',
            symbol : '€',
        },
    },
    priceCalcMode: '',
    priceDisplayMode: '',
};

const ECHO_WIDGET = 'echo';

const POINTS = 'PTS';

// To enhance the way each widget gets the params from settings. For being used in context and avoid prop drilling.
const SETTINGS_NEEDED_PARAMS = { rewardProgram: [ 'propertyCode', 'domain' ] };

// Keys linked maninly with redendering purposes and not with widgets business logic (As opposite to channelId, for instance)
const RENDERING_KEYS = [ 'container', 'isRendered', 'isDisabled' ];

/**
 * This constant hold the function names that each widget can have in the DOM.
 * There are two, to support both code snippets, the old and the new one. Feel free to add more when needed.
 */
const WIDGETS_FUNCTIONS = { rewardProgram: [ 'r', 'rewardProgram' ], searchbar: [ 'b', 'searchbar' ], hotels: [ 'l', 'hotelslist' ] };

module.exports = {
    SETTINGS_FIELDS,
    CUSTOMIZATION_FIELDS,
    DEFAULT_VALUES,
    ECHO_WIDGET,
    POINTS,
    BOOTSTRAP_CONFIG_KEYS,
    SETTINGS_NEEDED_PARAMS,
    RENDERING_KEYS,
    WIDGETS_FUNCTIONS,
};
